import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CustomerMobileCard = ({ customer, onClick }) => {
  const getStatusColor = (status) => {
    const colors = {
      inquiry: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
      planning: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
      permits: 'bg-warning/10 text-warning',
      construction: 'bg-accent/10 text-accent',
      completed: 'bg-success/10 text-success'
    };
    return colors?.[status] || colors?.inquiry;
  };

  const getAduTypeLabel = (type) => {
    const labels = {
      detached: 'Detached',
      attached: 'Attached',
      garage_conversion: 'Garage Conversion',
      basement_conversion: 'Basement Conversion'
    };
    return labels?.[type] || type;
  };

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div 
      onClick={onClick}
      className="bg-card rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer"
    >
      <div className="flex items-start gap-3 mb-3">
        <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-muted">
          <Image
            src={customer?.avatar}
            alt={customer?.avatarAlt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-foreground truncate">{customer?.name}</h3>
          <p className="text-sm text-muted-foreground truncate">{customer?.email}</p>
          <p className="text-sm text-muted-foreground mt-1">{customer?.phone}</p>
        </div>
        <Icon name="ChevronRight" size={20} className="text-muted-foreground flex-shrink-0" />
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Status:</span>
          <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium ${getStatusColor(customer?.projectStatus)}`}>
            {customer?.projectStatus?.charAt(0)?.toUpperCase() + customer?.projectStatus?.slice(1)}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">ADU Type:</span>
          <span className="text-sm font-medium text-foreground">{getAduTypeLabel(customer?.aduType)}</span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Last Contact:</span>
          <span className="text-sm font-medium text-foreground">{formatDate(customer?.lastContact)}</span>
        </div>
      </div>
    </div>
  );
};

export default CustomerMobileCard;